import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import React from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";

import FASvgIcon from "../FASvgIcon";
import GuardedComponent from "../GuardedComponent";

type Props = {
  popoverEvents: any[];
};

const RowActionOverlay: React.FC<Props> = (props: Props) => {
  const { popoverEvents } = props;

  return (
    <>
      <OverlayTrigger
        trigger="click"
        placement="auto-start"
        rootClose={true}
        overlay={
          <Popover className="popover-menu">
            <Popover.Body>
              {popoverEvents?.map((event, index) => (
                <GuardedComponent key={`event-${index}`} rules={event.actionRules} behavior="hide">
                  <Button
                    key={`event-${index}`}
                    variant="transparent"
                    className={classNames("popover-item", event.btnClass)}
                    onClick={() => {
                      document.body.click();
                      event.action();
                    }}
                  >
                    <FASvgIcon icon={event.icon} />
                    {event.title}
                  </Button>
                </GuardedComponent>
              ))}
            </Popover.Body>
          </Popover>
        }
      >
        <Button
          variant="transparent"
          className="icon-only btn-action"
          onClick={() => document.body.click()}
        >
          <FASvgIcon icon={faEllipsisV} />
        </Button>
      </OverlayTrigger>
    </>
  );
};

export default RowActionOverlay;
